// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"d8bb2b1f4eeab8f50472","3920":"156103e97e6acaa3e5c9","4057":"7f060b91eb87182bd8d6","5528":"a935886314d31c65a501","5771":"d141d1ad8187d99738b9","5862":"142cd48ca8ec32e57725","7462":"058eafd7294a2b1728f1","7471":"6423b9b898ffefeb7d1d","8057":"2c8f7e35c56e047ba73f"}[chunkId] + "";
};